/* istanbul ignore file */
import React from 'react';
import { DateInput, CommonDateInputProps } from 'framework/form';

const CalendarRightDateInput = (props: CommonDateInputProps) => {
  return (
    <div className="calendar-right">
      <DateInput {...props} />
    </div>
  );
};

export default CalendarRightDateInput;
